import React, { useContext, useEffect, useRef, useState } from "react";

import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { Dropdown } from "primereact/dropdown";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { chageEstadoAreas } from "../../../../../Base/API/Global/Areas/AreasRequests";
import { confirmDialog } from "primereact/confirmdialog";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { Toast } from "primereact/toast";

export const AreasScreen = ({
  areas,
  selected,
  setSelected,
  loading,
  showDialog,
  setShowDialog,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);
  const [estados, setEstado] = useState([])
  const toast = useRef(null)

  const ObtenerEstados = async() => {
    const estadosTempo = await getEstadosCategory('General')
    setEstado(estadosTempo.filter(i => i?.IdStatus !== 7))
     
  }

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            changes.push({
              IdArea: data.IdArea,
              IdStatus: e.value.IdStatus,
              StatusName: e.value.StatusName,
            });
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Area ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdAreas = changes.map((item) => item.IdArea);
                cambiarEstado(e.value.IdStatus, IdAreas.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };
  
  const cambiarEstado = async (IdStatus, IdAreas) => {
    const result = await chageEstadoAreas({ IdStatus, IdAreas });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const colums = [
    {
      field: "IdArea",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Area",
      header: "Nombre",
      headerEn: "Name",
      className: "XXlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Description",
      header: "Descripción",
      headerEn: "Description",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "Clasificacion",
      header: "Clasificación",
      className: "large",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      alignFrozen: "right",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: userAuth?.IdRol === 1 || userAuth?.IdRol === 36
    },
    {
      field: "IdArea",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: {
            position: "left",
          },
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: areas,
    loading: loading,
  };

  useEffect(() => {
    ObtenerEstados()
  }, []);

  return (
    <div
      className="p-fluid"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <AgGrid table={table} />
    </div>
  );
};

export default AreasScreen;
